module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"signDocument":"Sign Document"},"es":{"signDocument":"firmar documento"},"sw":{"signDocument":"saini Waraka"}}')
  delete Component.options._Ctor
}
